module.exports = "<div>\n  <h2 class=\"errorMessage\">Page Not Found</h2>\n</div>\n"